var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('poplist',{staticClass:"omni-tab",class:{ on: _vm.active }},[_c('template',{slot:"fuze"},[_vm._v(_vm._s(_vm.currentTab)),_c('i',{staticClass:"icon-downArrow"})]),_vm._v(" "),_c('itemlist',_vm._l((_vm.tablist),function(tab,key){return _c('li',{on:{"click":function($event){return _vm.handleClick(key, tab)}}},[_vm._v(_vm._s(tab))])}),0)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d4d97c1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tabBar/omniTab.vue
// module id = 0nrY
// module chunks = 29